const constants = {
  API_URL: process.env.REACT_APP_API_URL,
  REQUIRE_INTERCEPTORS: {
    requestHandlerEnabled: true,
    responseHandlerEnabled: true
  },
  CONTENT_SECTION: {
    ContentSectionTypeDefault: 'CONTENT_SECTION_DEFAULT',
    ContentSectionTypeReversed: 'CONTENT_SECTION_REVERSED',
    ContentSectionTypeFullWidth: 'CONTENT_SECTION_FULLWIDTH',
    ContentSectionTypeFullWidthPadded: 'CONTENT_SECTION_FULLWIDTH_PADDED',
    ContentSectionTypeTextOnly: 'CONTENT_SECTION_TEXTONLY',
    ContentSectionTypeCard: 'CONTENT_SECTION_CARD',
    ContentSectionTypeBanner: 'CONTENT_SECTION_BANNER',
    ContentSectionDynamicBanner: 'CONTENT_SECTION_DYNAMIC_BANNER',
    ContentSectionCustom: 'CONTENT_SECTION_CUSTOM',
    LeftAlignment: 'LEFT',
    RightAlignment: 'RIGHT',
    CenterAlignment: 'CENTER',
    ButtonActionTypePage: 'PAGE',
    ButtonActionTypeLink: 'LINK_NEW_TAB',
    ButtonActionTypePhoneNumber: 'PHONENUMBER',
    ButtonActionTypeEmail: 'EMAIL',
  },
  PAYPAL_CLIENT_ID: 'AWC-M7PJ0dKQzObA3lKocRfI4_6DMmirrohj7x0EP4Kd7pk6FWMU3WO-33E_ORMksyk9F8PWPK-KQk_d'
};

export default constants;